@for (tab of tabs; track tab.tabId; let index = $index) {
  <div class="tab-container" [attr.data-test-id]="tab.tabId" [class.selected]="index === selectedTabIndex">
    @if (useAsRouterLink) {
      <button
        type="button"
        class="tab"
        [routerLink]="tab.routerLink"
        (click)="selectTab(index, true)"
      >
        {{ tab.translationKey | translate: tab.translationKeyParams }}
      </button>
    } @else {
      <button class="tab" (click)="selectTab(index, true)">
        {{ tab.translationKey | translate: tab.translationKeyParams }}
      </button>
    }
  </div>
}
